import { render, staticRenderFns } from "./FormCompany.vue?vue&type=template&id=6b0a7714&scoped=true&"
import script from "./FormCompany.vue?vue&type=script&lang=js&"
export * from "./FormCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0a7714",
  null
  
)

export default component.exports